<template>
  <div id="appHeader" class="appHeader">
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="#"
          ><img height="30" src="../../assets/ondago_logo_gradient.png"
        /></a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="user != null">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" aria-current="page" to="/admin/overview">{{
                $t('admin.header.overview')
              }}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" aria-current="page" to="/admin/statistics">{{
                $t('admin.header.statistics')
              }}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/admin/maps">{{
                $t('admin.header.maps')
              }}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" aria-current="page" to="/admin/messagecenter"
                >{{ $t('admin.header.message_center')
                }}<!--<span class="badge bg-danger">??</span>--></router-link
              >
            </li>
          </ul>
          <div class="d-flex">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <router-link class="nav-link" aria-current="page" to="/admin/configuration"
                  ><img src="@/assets/buttons/configurationButton.png" width="30"
                /></router-link>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navBarLanguageSwitcherDropDown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  >{{ locale | fullLocale }}</a
                >
                <ul class="dropdown-menu" aria-labelledby="navBarLanguageSwitcherDropDown">
                  <li>
                    <a class="dropdown-item" href="#" v-on:click="setLocale('en')">{{
                      'en' | fullLocale
                    }}</a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" v-on:click="setLocale('fr')">{{
                      'fr' | fullLocale
                    }}</a>
                  </li>
                </ul>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle username-dropdown"
                  href="#"
                  id="navBarUserAccountDropDown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  >{{ user.email }}</a
                >
                <div class="current-publisher-name">
                  {{ publisherName(this.$store.state.currentPublisher) }}
                </div>
                <ul class="dropdown-menu" aria-labelledby="navBarUserAccountDropDown">
                  <!--<li><a class="dropdown-item" href="#" v-on:click="handleMyProfile()">{{ $t("admin.header.my_profile") }}</a></li>-->
                  <!--<div class="dropdown-divider"></div>-->
                  <li v-if="superadmin">
                    <router-link to="/system/overview" class="dropdown-item">{{
                      $t('admin.header.system_tools')
                    }}</router-link>
                  </li>
                  <div v-if="superadmin" class="dropdown-divider"></div>
                  <li v-for="publisher of publishers" v-bind:key="publisher.id">
                    <a
                      :class="publisherStyleClass(publisher)"
                      v-on:click="handlePublisherSelected(publisher)"
                      >{{ publisherName(publisher) }}</a
                    >
                  </li>
                  <div class="dropdown-divider"></div>
                  <li>
                    <a class="dropdown-item" href="#" v-on:click="handleLogout()">{{
                      $t('admin.header.logout')
                    }}</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import AuthenticationService from '@/service/AuthenticationService.js';
import PublisherService from '@/service/PublisherService.js';
import LangUtils from '@/utils/LangUtils.js';
import I18nMixin from '@/utils/I18nMixin';

const publisherService = new PublisherService();

export default {
  name: 'AppHeader',
  mixins: [I18nMixin],
  computed: {
    userEmail() {
      return this.$store.state.currentUser.email;
    },
  },
  data() {
    return {
      authenticationService: new AuthenticationService(),
      user: null,
      publishers: null,
      superadmin: false,
    };
  },
  methods: {
    publisherName(publisher) {
      return publisher != null
        ? LangUtils.valueForLanguage(publisher.getName(), this.$i18n.locale)
        : '';
    },

    publisherStyleClass(publisher) {
      const currentPublisher = this.$store.state.currentPublisher;
      if (publisher && this.$store.state.currentPublisher) {
        if (publisher.getId() == currentPublisher.getId()) {
          return 'dropdown-item dropdown-item-checked';
        }
      }

      return 'dropdown-item dropdown-item-not-checked';
    },

    languageSwitcherStyleClass(language) {
      if (language == this.$i18n.locale) {
        return 'dropdown-item dropdown-item-checked';
      } else {
        return 'dropdown-item';
      }
    },

    loadPublishers() {
      if (this.user) {
        publisherService
          .loadPublishersForUser(this.user.uid)
          .then((publishers) => {
            this.publishers = publishers;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    handleMyProfile() {
      alert('To do.');
    },

    handlePublisherSelected(publisher) {
      this.$store.commit('setCurrentPublisher', publisher);
      this.$router.replace('/admin/overview');
    },

    handleSystemAdministrationSelected() {
      this.$router.push({ path: '/admin/system' });
    },

    handleLogout() {
      const authenticationService = new AuthenticationService(this.$store);
      authenticationService
        .logout()
        .then(() => {
          this.$router.push({ path: '/login' });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type == 'setCurrentUser') {
        console.log('publisher changed');
        this.user = mutation.payload;
        this.loadPublishers();
      }
    });

    this.user = this.$store.state.currentUser;
    if (this.user) {
      this.loadPublishers();

      this.authenticationService
        .loadAuthenticatedUserProfile()
        .then((userProfile) => {
          this.superadmin = userProfile.superadmin;
        })
        .catch(() => {
          this.superadmin = false;
        });
    }
  },
};
</script>

<style scoped>
.appHeader {
    background-color: #ffffff;
}

.dropdown-item-checked::before {
  left: .4rem;
  content: '✓';
  font-weight: 600;
  margin-right: 8px;
}

.dropdown-item-not-checked::before {
  left: .4rem;
  content: '✓';
  font-weight: 600;
  color: #ffffff00;
  margin-right: 8px;
}

.badge {
    border-radius: 10px;
    position: relative;
    top: -10px;
}

.username-dropdown {
    padding-bottom: 0px;
}

.current-publisher-name {
    font-size: 12px;
    padding-right: 24px;
    text-align: right;
}
</style>
